import React, { useCallback, useState } from 'react';
import styled from 'astroturf/react';
import Modal from 'js/components/modals/Modal';
import { Body } from 'js/design_system/Body';
import { Button } from './design_system/Button';
import StarIcon from 'js/svg/colorless/star.svg';
import CloseIcon from 'js/design_system/icons/close.svg';
import ErrorIcon from 'js/design_system/icons/error.svg';
import _Container from "FeedbackModal-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/FeedbackModal.tsx?styleId=Container";
import _CloseContainer from "FeedbackModal-CloseContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/FeedbackModal.tsx?styleId=CloseContainer";
import _HeadingContainer from "FeedbackModal-HeadingContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/FeedbackModal.tsx?styleId=HeadingContainer";
import _Heading from "FeedbackModal-Heading.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/FeedbackModal.tsx?styleId=Heading";
import _Subtext from "FeedbackModal-Subtext.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/FeedbackModal.tsx?styleId=Subtext";
import _ResponseContainer from "FeedbackModal-ResponseContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/FeedbackModal.tsx?styleId=ResponseContainer";
import _StarContainer from "FeedbackModal-StarContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/FeedbackModal.tsx?styleId=StarContainer";
import _IconButton from "FeedbackModal-IconButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/FeedbackModal.tsx?styleId=IconButton";
import _ButtonContainer from "FeedbackModal-ButtonContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/FeedbackModal.tsx?styleId=ButtonContainer";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const CloseContainer = /*#__PURE__*/styled("div", null, {
  displayName: "CloseContainer",
  styles: _CloseContainer
});

const HeadingContainer = /*#__PURE__*/styled("div", null, {
  displayName: "HeadingContainer",
  styles: _HeadingContainer
});

const Heading = /*#__PURE__*/styled("p", null, {
  displayName: "Heading",
  styles: _Heading
});

const Subtext = /*#__PURE__*/styled(Body, null, {
  displayName: "Subtext",
  styles: _Subtext
});

const ResponseContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ResponseContainer",
  styles: _ResponseContainer
});

const StarContainer = /*#__PURE__*/styled("div", null, {
  displayName: "StarContainer",
  styles: _StarContainer
});

const IconButton = /*#__PURE__*/styled("button", null, {
  displayName: "IconButton",
  styles: _IconButton
});

const ButtonContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonContainer",
  styles: _ButtonContainer
});

type Props = {
  onClose: () => void;
  onSubmit: (rating: number) => void;
};

export const FeedbackModal: React.FC<Props> = ({ onClose, onSubmit }) => {
  const [rating, setRating] = useState<number>();
  const [showNag, setShowNag] = useState(false);

  const handleSubmit = useCallback(() => {
    if (!rating) {
      setShowNag(true);
    } else {
      onSubmit(rating);
    }
  }, [rating, onSubmit]);

  return (
    <Modal onClose={onClose}>
      <Container>
        <CloseContainer>
          <IconButton onClick={onClose}>
            <CloseIcon size={24} color="#6d6d7d" />
          </IconButton>
        </CloseContainer>

        <HeadingContainer>
          <Heading>How happy are you with our paper recommendations?</Heading>
          <Subtext size="sm">Your response is private</Subtext>
        </HeadingContainer>

        <ResponseContainer>
          <StarContainer>
            {[...Array(5)].map((_item, index) => (
              <IconButton key={index} onClick={() => setRating(index + 1)}>
                <StarIcon
                  size={38}
                  color={index + 1 > (rating ?? 0) ? '#cddaef' : '#386ac1'}
                />
              </IconButton>
            ))}
          </StarContainer>
          {showNag && !rating && (
            <Subtext size="sm">
              <ErrorIcon size={18} />
              Please provide your response
            </Subtext>
          )}
        </ResponseContainer>

        <ButtonContainer>
          <Button size="lg" onClick={handleSubmit}>
            Submit
          </Button>
        </ButtonContainer>
      </Container>
    </Modal>
  );
};
